import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'

import { UnespBreadcrumbItem, UnespBreadcrumbModule } from '@unesp/shared'
import { IdentificacaoUsuarioComponent } from 'src/app/shared/components/identificacao-usuario/identificacao-usuario.component'

@Component({
  imports: [CommonModule, UnespBreadcrumbModule, IdentificacaoUsuarioComponent],
  selector: 'app-em-desenvolvimento',
  templateUrl: './em-desenvolvimento.component.html',
  styleUrls: ['./em-desenvolvimento.component.css'],
})
export class EmDesenvolvimentoComponent {
  readonly breadcrumbs: UnespBreadcrumbItem[] = [
    { label: 'Home', route: '/', icon: 'home' },
    { label: 'Em Desenvolvimento', route: '/em-desenvolvimento', icon: 'construction' },
  ]
}
